import Panel from '@/views/Login/Panel.vue'
import router from '../../../router'
import { register, checkEmail } from '@/utils/requestHandler'

export default {
   name: 'Login',
   components: {
      Panel
   },
   data() {
      return {
         credentials: {
            firstName: '',
            lastName: '',
            username: '',
            company: '',
            email: '',
            phoneNumber: '',
            password: '',
            passwordRepeat: '',
            language: ''
         },
         firstNameValid: null,
         lastNameValid: null,
         usernameValid: null,
         uniqueUsername: true,
         emailValid: null,
         uniqueEmail: true,
         firmEmailValid: null,
         phonenumberValid: null,
         uniquePhonenumber: true,
         passwordValid: null,
         passwordRepeatValid: null,
         firmNameValid: null,
         html: '',
         hasRegistered: false,
         error: null,
         namePattern: /^[a-zA-ZàáâäãåąčćęèéêëėįìíîïłńòóôöõøùúûüųūÿýżźñçšžÀÁÂÄÃÅĄĆČĖĘÈÉÊËÌÍÎÏĮŁŃÒÓÔÖÕØÙÚÛÜŲŪŸÝŻŹÑßÇŒÆŠŽ∂ð ,.'-]+$/u
      }
   },
   methods: {
      selectFirstName(selection) {
         this.credentials.firstName = selection
      },
      isFirstNameValid() {
         this.firstNameValid = this.namePattern.test(this.credentials.firstName)
      },
      selectLastName(selection) {
         this.credentials.lastName = selection
      },
      isLastNameValid() {
         this.lastNameValid = this.namePattern.test(this.credentials.lastName)
      },
      selectUsername(selection) {
         this.credentials.username = selection
         this.uniqueUsername = true
      },
      isUsernameValid() {
         const usernamePattern = /^[a-zA-Z0-9_-]{5,15}$/
         this.usernameValid = usernamePattern.test(this.credentials.username)
      },
      selectCompany(selection) {
         this.credentials.company = selection
      },
      isCompanyValid() {
         const firmNamePattern = /^[a-zA-Z0-9àáâäãåąčćęèéêëėįìíîïłńòóôöõøùúûüųūÿýżźñçšžÀÁÂÄÃÅĄĆČĖĘÈÉÊËÌÍÎÏĮŁŃÒÓÔÖÕØÙÚÛÜŲŪŸÝŻŹÑßÇŒÆŠŽ∂ð ,.'-]+$/u
         this.firmNameValid = firmNamePattern.test(this.credentials.company)
      },
      selectEmail(selection) {
         this.credentials.email = selection
      },
      async isEmailValid() {
         let email = this.credentials.email
         const emailPattern = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
         this.emailValid = emailPattern.test(email)
         if (this.emailValid) {
            this.firmEmailValid = await checkEmail(email)
         }
         this.uniqueEmail = true
      },
      selectPhoneNumber(selection) {
         this.credentials.phoneNumber = selection
      },
      isPhoneNumberValid() {
         const phoneNumberPattern = /^[+]*[(]{0,1}[0-9]{1,4}[)]{0,1}[-\s./0-9]*$/
         this.phonenumberValid = phoneNumberPattern.test(this.credentials.phoneNumber)
         this.uniquePhonenumber = true
      },
      selectPassword(selection) {
         this.credentials.password = selection
      },
      selectPasswordRepeat(selection) {
         this.credentials.passwordRepeat = selection
      },
      isPasswordValid() {
         const passwordPattern = /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[+"*#%[&\]/|\\({)}='?^`¨!$£\-_.:,;@€§°]).{8,}$/
         this.passwordValid = passwordPattern.test(this.credentials.password)
      },
      isPasswordRepeatValid() {
         this.passwordRepeatValid = this.credentials.password === this.credentials.passwordRepeat
      },

      async signUp() {
         // Here is the method to signUp for SBCGoLight
         this.isFirstNameValid()
         this.isLastNameValid()
         this.isUsernameValid()
         this.isEmailValid()
         this.isPhoneNumberValid()
         this.isPasswordValid()
         this.isPasswordRepeatValid()
         this.isCompanyValid()
         if (
            this.passwordValid &&
            this.passwordRepeatValid &&
            this.phonenumberValid &&
            this.emailValid &&
            this.usernameValid &&
            this.firstNameValid &&
            this.lastNameValid &&
            this.firmNameValid
         ) {
            this.credentials.language = this.$i18n.locale
            let response = await register(this.credentials)
            if (response.status === 200) {
               this.hasRegistered = true
            } else {
               response = response.response
               if (response.data === 'Email is already taken') {
                  this.uniqueEmail = false
                  this.emailValid = false
               } else if (response.data === 'Username is already taken') {
                  this.usernameValid = false
                  this.uniqueUsername = false
               } else if (response.data === 'Phone number is already taken') {
                  this.phonenumberValid = false
                  this.uniquePhonenumber = false
               } else {
                  this.error = response.data
               }
            }
         }
      },
      login() {
         router.push({ name: 'Login' })
      }
   }
}
